export default "__VITE_ASSET__De0Ul1_k__"